import React from 'react';
import { FormattedMessage } from 'react-intl';
import { IconSlimCheck } from 'src/easyclaim.app.assets/icons/IconSlimCheck';
import { CustomerConfiguration } from 'src/easyclaim.app.contexts/CustomerConfigurationContextCore';
import styled from 'styled-components';

import { IconCheck } from '../easyclaim.app.assets/index';
import { CenteredCircle, GrowingDetailContainer } from '../easyclaim.app.components/index';
import theme from '../easyclaim.app.theme/theme';

import { FinishedV2 } from './FinishedV2';

export const WaitForAudit = () => {
	const customerConfiguration = CustomerConfiguration();
	const useSolvdStyles = customerConfiguration?.useSolvdStyles;

	return (
		<div className="main-container">
			{useSolvdStyles && <FinishedV2 />}
			{!useSolvdStyles && (
				<>
					<h2 className="wait-for-audit-headline">
						<FormattedMessage id="waitForAudit.thankYou" />
					</h2>
					<GrowingDetailContainer>
						{!!customerConfiguration &&
						!!customerConfiguration.additionalStyleFileName &&
						customerConfiguration.additionalStyleFileName.length > 0 ? (
							<>
								<div className="feedback-confirmation-icon"></div>
								<div className="wait-for-audit-confirmation-icon">
									<CenteredCircle
										size="3.5rem"
										borderColor="#007AB3"
										borderStyle="solid"
										borderWidth="2px"
									>
										<SlimStyledCheckIcon />
									</CenteredCircle>
								</div>
							</>
						) : (
							<CenteredCircle
								size="6rem"
								borderColor={theme.colors.success}
								borderStyle="solid"
								borderWidth="3px"
							>
								<StyledCheckIcon />
							</CenteredCircle>
						)}
						<p className="wait-for-audit-text">
							{true ? (
								<FormattedMessage id="waitForAudit.description.damageFound" />
							) : (
								<FormattedMessage id="waitForAudit.description.damageNotFound" />
							)}
						</p>
					</GrowingDetailContainer>
				</>
			)}
		</div>
	);
};

const StyledCheckIcon = styled(IconCheck)`
	height: 4rem;
	vertical-align: text-bottom;
	color: ${(p) => p.theme.colors.success};
`;

const SlimStyledCheckIcon = styled(IconSlimCheck)`
	height: 4rem;
	vertical-align: text-bottom;
	color: #007ab3;
`;
